export default "__VITE_ASSET__sNlh1Ink__"